import { useQuizContext } from "./QuizContext";
import { writeResultsStepToURL } from "./urlState";

export function useResultsStep() {
  const { state, dispatch } = useQuizContext();

  const resultsStep = state.resultsStep ?? 1;

  const setResultsStep = (step: number) => {
    dispatch({ type: "SET_RESULTS_STEP", step });
    writeResultsStepToURL(step);
  };

  return { resultsStep, setResultsStep };
}
